// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { UserState } from './user-details/user-details.interfaces';
import { Store, select } from '@ngrx/store';
import { selectUsers, LoadingUsersAction } from '@app/access-management/state';
import { Loadable, needsLoading, Loaded, IAMUser, MaybeLoadable, GoAction } from '@app/core';
import { take, filter, map } from 'rxjs/operators';
import { SelectUserAction } from './user-details/user-details.actions';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
var shouldLoadUsers = function (users) { return needsLoading(users); };
var ɵ0 = shouldLoadUsers;
var hasUsersState = function (users) { return !needsLoading(users); };
var ɵ1 = hasUsersState;
var UsersFacadeService = /** @class */ (function () {
    function UsersFacadeService(store) {
        this.store = store;
        this.loadableUsers$ = this.store.pipe(select(selectUsers));
        this.users$ = this.loadableUsers$.pipe(filter(hasUsersState), map(function (userList) { return userList.data; }));
    }
    UsersFacadeService.prototype.initialize = function () {
        var _this = this;
        this.loadableUsers$.pipe(take(1), filter(shouldLoadUsers))
            .subscribe(function () { return _this.store.dispatch(new LoadingUsersAction()); });
    };
    UsersFacadeService.prototype.selectUser = function (user) {
        this.store.dispatch(new SelectUserAction(user));
        this.store.dispatch(new GoAction(['/iam/users', user.username]));
    };
    UsersFacadeService.ngInjectableDef = i0.defineInjectable({ factory: function UsersFacadeService_Factory() { return new UsersFacadeService(i0.inject(i1.Store)); }, token: UsersFacadeService, providedIn: "root" });
    return UsersFacadeService;
}());
export { UsersFacadeService };
export { ɵ0, ɵ1 };



// WEBPACK FOOTER //
// ./src/app/access-management/state/users.facade.ts.pre-build-optimizer.js